import React, { Component } from "react";
import { connect } from "react-redux";
import {
  closeAdvancedSettings,
  setOrUpdateStyles,
} from "../../../../_actions/sidebarSliderActions";
import { ADD_MASK } from "../../../../_actions/types";
import { TldrBadge } from "../../../common/statelessView";
import { IMAGES_SLIDER_PANEL } from "../../constants";
import { StyledTextEditorToolbarFormatGroup } from "./../../../styled/details/stylesDetails";
import {
  Tooltip,
  ButtonGroup,
  IconButton,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
} from "@chakra-ui/react";
import { FaChevronDown, FaCropAlt, FaImage } from "react-icons/fa";
import { withTranslation } from "react-i18next";

class TLDRTextMask extends Component {
  render() {
    const { location, t } = this.props;
    const menuContent = <ButtonGroup isAttached>
      <Tooltip
        placement={this.props.isMobileView ? "top" : "bottom"}
        hasArrow
        label={t("fonts.replace_mask")}
        shouldWrapChildren
      >
        <IconButton
          icon={<FaImage />}
          onClick={() => this.replaceMaskImage(ADD_MASK)}
          sx={{
            borderRadius: "0.375rem 0 0 0.375rem",
            maxHeight: "35px",
          }}
        />
      </Tooltip>
      <Menu isLazy>
        <MenuButton
          as={IconButton}
          icon={<FaChevronDown />}
          sx={{
            borderRadius: "0 0.375rem 0.375rem 0",
            maxHeight: "35px",
          }}
        />
        <MenuList>
          <MenuItem
            onClick={() => this.replaceMaskImage(ADD_MASK)}
            icon={<FaImage />}
          >
            {t("fonts.replace_mask")}
          </MenuItem>
          <MenuItem onClick={this.adjustMask} icon={<FaCropAlt />}>
            {t("fonts.adjust_mask")}
          </MenuItem>
        </MenuList>
      </Menu>
    </ButtonGroup>

    return (
      <>
        <div className="tldr-vl" />
        <StyledTextEditorToolbarFormatGroup
          className={location === "sidebar" ? "" : ""}
        >
          {this.props.isMobileView ? menuContent : <TldrBadge
            hide={this.props.isMobileView ? true : false}
            badgeText={t("new", { ns: "common" })}
          >
            {menuContent}
          </TldrBadge>}
        </StyledTextEditorToolbarFormatGroup>
      </>
    );
  }

  replaceMaskImage = (action) => {
    this.props.setOrUpdateStyles(action, IMAGES_SLIDER_PANEL);
  };

  adjustMask = (action) => {
    if (this.props.rightsidebar.isActionPanelOpen) {
      this.props.closeAdvancedSettings();
    }
    this.props.canvasRef.handler.maskHandler.start();
  };
}

TLDRTextMask.propTypes = {};

const mapStateToProps = (state) => ({
  rightsidebar: state.rightsidebar,
  isMobileView: state.app.isMobileView,
});

const mapDispatchToProps = (dispatch) => ({
  setOrUpdateStyles: (action, destination) =>
    dispatch(setOrUpdateStyles(action, destination)),
  closeAdvancedSettings: () => dispatch(closeAdvancedSettings()),
});

export default withTranslation(["studio", "common"])(
  connect(mapStateToProps, mapDispatchToProps)(TLDRTextMask)
);
